import { IconBackChevron } from 'App/components/icons/IconBackChevron/IconBackChevron'

export const BackButton = ({ resetProductForm }: { resetProductForm: () => void }) => {
  return (
    <span css={{ fontSize: 18, cursor: 'pointer', padding: 2 }} onClick={resetProductForm}>
      <IconBackChevron />
    </span>
  )
}
